import {LitElement, html, css} from 'lit';
import {customElement} from 'lit/decorators/custom-element.js';
import {when} from 'lit/directives/when.js';
import {msg} from '@lit/localize';
import {connect} from 'pwa-helpers';
import store from '../../../store';
import {zoneOptions} from '../../../sectionConfig';


@customElement('visual-lightprofile-zone')
export class VisualLightprofileZone extends connect(store)(LitElement) {

	static styles = css`
	  :host {
		display: flex;
		width: 100%;
	  }
	  .container {
		display: flex;
		gap: 10px;
		flex-direction: row;
		align-items: end;
		height: 100%;
		width: 100%;
	  }
	  .overlay {
		display: flex;
		flex-direction: column;
		width: 100%;
	  }
	  .defaultZone {
		width: 100%;
		height: 100vh;
		z-index: -1;
		position: absolute;
	  }
	  .zoneProfile {
		display: block;
		width: 100vw;
		z-index: -1;
		position: absolute;
	  }
	 .zoneProfileImg {
	   position: fixed;
	   bottom: 0;
	   left: 0;
	   right: 0;
	   width: 100%;
	   height: 100%;
	   object-fit: cover;
	   object-position: center center;
	  }

	  .overlay {
		background:linear-gradient(0deg, rgba(0, 0, 0, 0.2) 6.09%, rgba(0, 0, 0, 0) 35.62%), linear-gradient(89.55deg, rgba(0, 0, 0, 0.5) 1.94%, rgba(0, 0, 0, 0) 99.61%);
		position: fixed;
		bottom: 0;
		left: 0;
		right: 0;
		width: 100%;
		height: 100%;
		margin: 0;
		box-sizing: border-box;
	  }
	  .defaultLocation {
		width: 100%;
		z-index: -1;
		position: absolute;
	  }
	  .defaultLocationMobile {
		display: none;
	  }

	  .zoneInfo {
		position: absolute;
		bottom: var(--large-padding);
		left: var(--large-padding);
		right: var(--large-padding);
	}
	  .title {
		font: var(--font-small-title);
		color: var(--color-white);
		margin-bottom: 0;
		border-bottom: 1px solid grey;
		padding-bottom: 20px;
	  }
	  .info {
		color: var(--color-white);
		font: var(--font-info-light);
		line-height: 30px;
		height: 100px;
		width: 60%;
	  }
	  @media (max-width: 768px) {
		.overlay {
			background-image: linear-gradient(rgba(0, 0, 0, 0.3) 10.56%, rgba(0, 0, 0, 0) 23.43%), linear-gradient(90deg, rgba(0, 0, 0, 0.2) 22.75%, rgba(0, 0, 0, 0) 100%), linear-gradient(0deg, rgb(0, 0, 0) 0%, rgba(0, 0, 0, 0) 36%)
		}
		.zoneInfo {
			bottom: 120px;
			left: 16px;
			right: 16px;
		}
		.zoneInfo.empty {
			bottom: 120px;
		}
		.info {
			font: var(--font-summary-paragraph);
			width: 100%;
			line-height: 25px;
		}
		.title {
			font: var(--font-mobile-title);
		}
		.moreInfo {
			position: initial;
			float: left;
		}
		.defaultLocationMobile {
			display: block;
			width: 100%;
			z-index: -1;
			position: absolute;
		}
		.defaultLocation {
			display: none;
		}
	 }
	`;

	constructor() {
		super();
		store.subscribe(() => this.requestUpdate());
	}
	stateChanged(state) {
		this.state = state;
		this.lang = state.status.lang;
		this.lightProfile = state.lightProfile.data;
		this.zone = zoneOptions.find(zone => zone.id === this.lightProfile.project.zone);
	}

	render() {
		const s = this.state;
		return html`
			<div class="container">
			<img class="defaultLocation" src="/line-assets/img/zone_default.png"/>
			<img class="defaultLocationMobile" src="/line-assets/img/zone_default_mobile.png"/>

				${when(this.zone,
						() => html`
						<div class="zoneProfile">
							<img class="zoneProfileImg" src="${this.zone.image}" alt=""/>
							<div class="overlay"></div>
							<div class="zoneInfo">
								<h1 class="title">${this.zone.label[this.lang]}</h1>
								<p class="info">${this.zone.description[this.lang]}</p>
							</div>
						</div>
						`,
						() => html`
						<div class="zoneInfo">
							<h1 class="title">${msg('Your Zone:')}</h1>
						</div>
						`
				)}
			</div>

		`;
	}
}
